import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";
import LeaveApprovalModal from "./LeaveApprovalModal"; // Bạn cần đảm bảo đã tạo Modal này

const LeaveApprovalConfigList = () => {
  const [configs, setConfigs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingConfig, setEditingConfig] = useState(null);

  useEffect(() => {
    fetchConfigs();
  }, []);

  // Lấy toàn bộ cấu hình duyệt nghỉ phép
  const fetchConfigs = async () => {
    try {
      const res = await axiosClient.get(API_ENDPOINTS.leaveApprovalConfigs);
      setConfigs(res.data || []);
    } catch (error) {
      console.error("❌ Error loading leave configurations:", error);
    }
  };

  // Xóa một bước cấu hình duyệt
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this leave approval step?")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.leaveApprovalConfigs}/${id}`);
      fetchConfigs();
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Delete failed! Please try again.");
    }
  };

  // Lưu cấu hình (Thêm mới hoặc Cập nhật)
  const handleSave = async (data) => {
    try {
      if (editingConfig && editingConfig.id) {
        await axiosClient.put(`${API_ENDPOINTS.leaveApprovalConfigs}/${editingConfig.id}`, data);
      } else {
        await axiosClient.post(API_ENDPOINTS.leaveApprovalConfigs, data);
      }
      fetchConfigs();
      setShowModal(false);
      setEditingConfig(null);
    } catch (error) {
      console.error("Save error:", error);
      alert("Error saving leave configuration!");
    }
  };

  const sortedData = [...configs].sort((a, b) => a.stepOrder - b.stepOrder);

  const renderPosition = (pos) => {
    const positions = { 0: "General Staff", 1: "Department Manager", 2: "Division Manager", 3: "Board of Directors" };
 
    return positions[pos] || pos || "N/A";
  };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="m-0 font-weight-bold text-dark">LEAVE REQUEST APPROVAL WORKFLOW</h5>
            <p className="text-muted small mb-0">Configure the sequential chain for leave request approvals</p>
          </div>
          <button
            className="btn btn-sm btn-primary px-3 rounded-pill shadow-sm"
            onClick={() => {
              setEditingConfig({ stepOrder: sortedData.length + 1, position: 0 });
              setShowModal(true);
            }}
          >
            <i className="fas fa-plus me-1"></i> Add Step
          </button>
        </div>

        <div className="card-body p-0">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="text-center">Sequence</th>
                <th>Approver</th>
                <th>Required Position</th>
                <th>Note</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((c) => (
                <tr key={c.id}>
                  <td className="text-center">
                    <span className="badge bg-primary rounded-circle">{c.stepOrder}</span>
                  </td>
                  <td>
                    <div className="fw-bold">{c.approver?.employeeLeaveDetail.fullName || "Unassigned"}</div>
                    <small className="text-muted">{c.approver?.email}</small>
                  </td>
                  <td>{renderPosition(c.position)}</td>
                  <td>{c.note || "-"}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => { setEditingConfig(c); setShowModal(true); }}>
                      <i className="fas fa-pencil-alt"></i>
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(c.id)}>
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <LeaveApprovalModal
          show={showModal}
          initialData={editingConfig}
          onClose={() => { setShowModal(false); setEditingConfig(null); }}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default LeaveApprovalConfigList;